/* eslint-disable import/no-cycle */
/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable prefer-const */
/* eslint-disable no-return-assign */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-continue */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-else-return */
/* eslint-disable @typescript-eslint/prefer-regexp-exec */

import isString from 'lodash/isString';
import isUndefined from 'lodash/isUndefined';
import isObject from 'lodash/isObject';
import { v4 as uuidv4 } from 'uuid';
import { DRAG_ITEM_TYPES } from './constants';
import { ComponentInputTypeT } from './schemas/types';
import { DraggedItem, FormFieldQuestionT, FormFieldT, FormItemT, FormSectionT, TextWithTranslationsT } from './types';
import { COMPONENT_ADVANCED_FIELDS } from './schemas/formComponentFieldSchema';
import { FORM_COMPONENT_BASIC_INPUT_TYPE } from './schemas/formComponentInputTypeSchema';
import { getFormSchemaByInputType } from './schemas/formFieldSchema';

export function isFieldSchema(item: FormItemT | FormFieldT | FormSectionT): item is FormFieldT {
  return item && isString((item as FormFieldT).inputType) && !('fields' in item);
}

export function isSectionSchema(item: FormItemT | FormFieldT | FormSectionT): item is FormSectionT {
  return (
    item &&
    isString((item as FormSectionT).section) &&
    Array.isArray((item as FormSectionT).fields) &&
    isUndefined((item as FormFieldT).inputType)
  );
}

export const deepClone = <T>(obj: T): T => {
  return JSON.parse(JSON.stringify(obj)) as T;
};

export const findItemAndParentByPath = (
  formItems: FormItemT[],
  path: number[],
): { item: FormItemT | null; parent: FormItemT[] | null; itemIndex: number } => {
  let currentLevel = formItems;
  let parent: FormItemT[] | null = null;
  let item: FormItemT | null = null;
  let itemIndex = -1;

  for (let i = 0; i < path.length; i++) {
    const index = path[i];
    if (!currentLevel || index < 0 || index >= currentLevel.length) {
      return { item: null, parent: null, itemIndex: -1 };
    }
    if (i === path.length - 1) {
      item = currentLevel[index];
      parent = currentLevel;
      itemIndex = index;
    } else {
      const nextItem = currentLevel[index];
      if ('fields' in nextItem) {
        parent = currentLevel;
        currentLevel = (nextItem as FormSectionT).fields;
      } else if (nextItem.inputType === 'yesNo' && 'followUpQuestionList' in nextItem && nextItem.followUpQuestionList) {
        parent = currentLevel;
        currentLevel = (nextItem as FormFieldT).followUpQuestionList as FormItemT[];
      } else {
        return { item: null, parent: null, itemIndex: -1 };
      }
    }
  }
  return { item, parent, itemIndex };
};

export const removeItemByPath = (formItems: FormItemT[], path: number[]): FormItemT[] => {
  const items = deepClone(formItems);
  let currentLevel: FormItemT[] | (FormFieldT | FormSectionT)[] | any = items;
  let parentList: FormItemT[] | (FormFieldT | FormSectionT)[] | null = items;
  let itemIndexToRemove = -1;

  for (let i = 0; i < path.length; i++) {
    const index = path[i];
    if (i === path.length - 1) {
      itemIndexToRemove = index;
      parentList = currentLevel;
    } else {
      const parentItem = currentLevel[index];
      if (isSectionSchema(parentItem)) {
        currentLevel = (parentItem as FormSectionT).fields;
      } else if (
        isFieldSchema(parentItem) &&
        parentItem.inputType === 'yesNo' &&
        (parentItem as FormFieldT).followUpQuestionList
      ) {
        currentLevel = (parentItem as FormFieldT).followUpQuestionList;
      } else {
        console.error('Invalid path for removal');
        return formItems;
      }
    }
  }

  if (parentList && itemIndexToRemove !== -1 && parentList.length > itemIndexToRemove) {
    parentList.splice(itemIndexToRemove, 1);
  } else {
    console.error('Could not remove item at path:', path);
  }

  return items;
};

export const addItemByPath = (
  formItems: FormItemT[],
  path: number[],
  index: number,
  newItem: FormItemT,
  optionId?: string,
): FormItemT[] => {
  const items = deepClone(formItems);
  let currentLevel: FormItemT[] = items;
  const itemToAdd = { ...newItem };

  if (path.length === 0) {
    currentLevel.splice(index, 0, itemToAdd);
    return items;
  }

  let targetContainer: FormItemT[] | null = items;

  for (let i = 0; i < path.length; i++) {
    const pathIndex = path[i];
    const parentItem: FormItemT | null = targetContainer[pathIndex] || null;
    if (isSectionSchema(parentItem)) {
      targetContainer = parentItem.fields;
    } else if (parentItem && parentItem.inputType === 'yesNo' && (parentItem as FormFieldT).followUpQuestionList) {
      targetContainer = (parentItem as FormFieldT).followUpQuestionList as FormItemT[];
      if (optionId) {
        itemToAdd.optionId = optionId;
        if (isSectionSchema(itemToAdd)) {
          itemToAdd?.fields?.map((f) => (f.optionId = optionId));
        }
      }
    } else {
      console.error('Invalid path for insertion, container not found at segment:', pathIndex, parentItem);
      return formItems;
    }
  }

  if (targetContainer) {
    targetContainer.splice(index, 0, itemToAdd);
  } else {
    console.error('Target container not found for insertion at path:', path);
  }

  return items;
};

export function findIndexPathById(items: FormItemT[], targetId: string): number[] | null {
  if (!items || !Array.isArray(items)) {
    return null;
  }

  for (let i = 0; i < items.length; i++) {
    const item = items[i];

    if (!item || isUndefined(item.id)) {
      continue;
    }

    if (item.id === targetId) {
      return [i];
    }

    if ('fields' in item && Array.isArray((item as FormSectionT).fields)) {
      const section = item as FormSectionT;
      const subPath = findIndexPathById(section.fields, targetId);
      if (subPath) {
        return [i, ...subPath];
      }
    } else if (
      !('fields' in item) &&
      (item as FormFieldT).inputType === 'yesNo' &&
      Array.isArray((item as FormFieldT).followUpQuestionList)
    ) {
      const fieldWithFollowUps = item as FormFieldT;
      if (fieldWithFollowUps.followUpQuestionList) {
        const subPath = findIndexPathById(fieldWithFollowUps.followUpQuestionList, targetId);
        if (subPath) {
          return [i, ...subPath];
        }
      }
    }
  }

  return null;
}

export function getJoiPathFromNumericalPath(numericalPath: number[], schema: FormItemT[]): (string | number)[] {
  const joiPath: (string | number)[] = [];
  let currentLevelItems: FormItemT[] | undefined | null = schema;

  for (let i = 0; i < numericalPath.length; i++) {
    const index = numericalPath[i];
    if (!currentLevelItems || index < 0 || index >= currentLevelItems.length) {
      return numericalPath;
    }

    const currentItem: FormItemT | null = currentLevelItems?.[index] || null;
    joiPath.push(index);

    if (i < numericalPath.length - 1) {
      if ('fields' in currentItem && Array.isArray(currentItem.fields)) {
        currentLevelItems = currentItem.fields;
      } else if (
        'inputType' in currentItem &&
        currentItem?.inputType === 'yesNo' &&
        Array.isArray((currentItem as FormFieldT).followUpQuestionList)
      ) {
        currentLevelItems = (currentItem as FormFieldT).followUpQuestionList;
      } else {
        return numericalPath;
      }
    }
  }
  return joiPath;
}

export function findItemByPath(schema: FormItemT[], path: number[]): FormItemT | null {
  if (!path || path.length === 0) return null;

  let currentLevel: FormItemT[] | undefined | null = schema;
  let item: FormItemT | null = null;

  for (let i = 0; i < path.length; i++) {
    const index = path[i];
    if (!currentLevel || index < 0 || index >= currentLevel.length) {
      return null;
    }
    item = currentLevel[index];
    if (i < path.length - 1) {
      if (isSectionSchema(item) && item.fields) {
        currentLevel = item.fields;
      } else if (isFieldSchema(item) && item.inputType === 'yesNo' && item.followUpQuestionList) {
        currentLevel = item.followUpQuestionList;
      } else {
        return null;
      }
    }
  }
  return item;
}

function pathsAreEqual(path1: number[], path2: number[]): boolean {
  if (path1.length !== path2.length) {
    return false;
  }
  for (let i = 0; i < path1.length; i++) {
    if (path1[i] !== path2[i]) {
      return false;
    }
  }
  return true;
}

function isAncestor(path1: number[], path2: number[]): boolean {
  if (path1.length >= path2.length) {
    return false;
  }
  for (let i = 0; i < path1.length; i++) {
    if (path1[i] !== path2[i]) {
      return false;
    }
  }
  return true;
}

export function adjustTargetPathAfterRemoval(sourcePath: number[], targetPath: number[]): number[] | null {
  if (pathsAreEqual(sourcePath, targetPath)) {
    return null;
  }

  if (isAncestor(sourcePath, targetPath)) {
    return null;
  }

  if (isAncestor(targetPath, sourcePath)) {
    return [...targetPath];
  }

  let lcpLength = 0;
  while (lcpLength < sourcePath.length && lcpLength < targetPath.length && sourcePath[lcpLength] === targetPath[lcpLength]) {
    lcpLength++;
  }

  if (sourcePath.length === lcpLength + 1) {
    if (lcpLength < targetPath.length && sourcePath[lcpLength] < targetPath[lcpLength]) {
      const newTargetSegment = targetPath[lcpLength] - 1;
      return [...targetPath.slice(0, lcpLength), newTargetSegment, ...targetPath.slice(lcpLength + 1)];
    } else {
      return [...targetPath];
    }
  } else {
    return [...targetPath];
  }
}

export const getOptionIdForItem = (item: FormItemT): string | null | undefined => {
  if (!item) {
    return null;
  }

  if (isFieldSchema(item)) {
    const field = item;
    return field.optionId;
  } else if (isSectionSchema(item)) {
    const section = item;
    if (isSectionSchema(section) && section.fields.length === 0) {
      return section.optionId;
    }

    const findRecursive = (currentItems: FormItemT[]): string | null | undefined => {
      for (const subItem of currentItems) {
        if (!subItem) continue;
        if (isFieldSchema(subItem)) {
          const field = subItem;
          if (field.optionId) return field.optionId;
        } else if (isSectionSchema(subItem)) {
          const nestedSection = subItem;
          const foundInNested = findRecursive(nestedSection.fields);
          if (foundInNested) return foundInNested;
        }
      }
      return null;
    };
    return findRecursive(section.fields);
  }
  return null;
};

export function hasSectionWithName(items: FormItemT[], sectionNameToFind: string, ignoreSectionId?: string): boolean {
  if (!Array.isArray(items) || items.length === 0 || !sectionNameToFind) {
    return false;
  }

  for (const item of items) {
    if (!item) continue;

    if (isSectionSchema(item)) {
      if (item.id === ignoreSectionId) {
        if (hasSectionWithName(item.fields, sectionNameToFind, ignoreSectionId)) {
          return true;
        }
        continue;
      }

      let currentItemSectionName: string | undefined;
      if (isString(item.section)) {
        currentItemSectionName = item.section;
      } else if (item.section && isObject(item.section) && item.section) {
        currentItemSectionName = item.section;
      } else if (item.section && isObject(item.section) && item.section['en']) {
        currentItemSectionName = item.section['en'];
      }

      if (currentItemSectionName === sectionNameToFind) {
        return true;
      }

      if (hasSectionWithName(item.fields, sectionNameToFind, ignoreSectionId)) {
        return true;
      }
    } else if (isFieldSchema(item) && Array.isArray(item.followUpQuestionList)) {
      if (hasSectionWithName(item.followUpQuestionList, sectionNameToFind, ignoreSectionId)) {
        return true;
      }
    }
  }

  return false;
}

export function dragPreviewNode(e: React.DragEvent, current: HTMLDivElement) {
  const previewNode = current.cloneNode(true) as HTMLElement;
  previewNode.style.position = 'absolute';
  previewNode.style.top = '-9999px';
  previewNode.style.left = '-9999px';
  previewNode.style.width = '300px';
  previewNode.style.pointerEvents = 'none';
  previewNode.style.opacity = '0.85';
  previewNode.style.backgroundColor = 'white';
  previewNode.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
  previewNode.style.padding = current.style.padding || '1rem';
  previewNode.style.border = current.style.border || '1px solid #e2e8f0';
  previewNode.style.borderRadius = current.style.borderRadius || '0.375rem';

  const elementsToHide = previewNode.querySelectorAll('.hide-in-drag-preview');
  elementsToHide.forEach((el) => ((el as HTMLElement).style.display = 'none'));

  document.body.appendChild(previewNode);
  e.dataTransfer.setDragImage(previewNode, 20, 20);

  setTimeout(() => {
    if (previewNode.parentNode) {
      previewNode.parentNode.removeChild(previewNode);
    }
  }, 0);
}

export function flattenToFormFields(formItems: FormItemT[]): FormFieldT[] {
  const allFields: FormFieldT[] = [];

  function processItems(items: FormItemT[] | null | undefined): void {
    if (!items || items.length === 0) {
      return;
    }

    for (const item of items) {
      if (isFieldSchema(item)) {
        const formField = item as FormFieldT;
        allFields.push(formField);

        if (formField.followUpQuestionList && formField.followUpQuestionList.length > 0) {
          processItems(formField.followUpQuestionList);
        }
      } else if (isSectionSchema(item) && Array.isArray(item.fields)) {
        const formSection = item as FormSectionT;
        processItems(formSection.fields);
      }
    }
  }

  processItems(formItems);

  return allFields;
}

export function flattenFieldsPreservingFollowUpStructure(formItems: FormItemT[]): FormFieldQuestionT[] {
  const result: FormFieldQuestionT[] = [];

  function processFollowUpListInternal(followUpItems: FormItemT[] | null | undefined): FormFieldQuestionT[] {
    if (!followUpItems || followUpItems.length === 0) {
      return [];
    }

    const processedList: FormFieldQuestionT[] = [];
    for (const followUpItem of followUpItems) {
      if (isFieldSchema(followUpItem)) {
        const nestedField = { ...followUpItem } as FormFieldQuestionT;
        nestedField.followUpQuestionList = processFollowUpListInternal(nestedField.followUpQuestionList as FormItemT[]);
        processedList.push(nestedField);
      } else if (isSectionSchema(followUpItem)) {
        const sectionFieldsAsFormItems = processFollowUpListInternal((followUpItem as FormSectionT).fields);
        processedList.push(...sectionFieldsAsFormItems);
      }
    }
    return processedList;
  }

  for (const item of formItems) {
    if (isFieldSchema(item)) {
      const formField = { ...item } as FormFieldQuestionT;
      formField.followUpQuestionList = processFollowUpListInternal(formField.followUpQuestionList as FormItemT[]);
      result.push(formField);
    } else if (isSectionSchema(item)) {
      result.push(...flattenFieldsPreservingFollowUpStructure(item.fields));
    }
  }
  return result;
}

export function flattenSectionFieldsOnly(formItems: FormItemT[]): FormFieldT[] {
  const sectionFields: FormFieldT[] = [];

  function processItemsRecursive(items: FormItemT[] | null | undefined, isInSectionContext: boolean): void {
    if (!items || items.length === 0) {
      return;
    }
    for (const item of items) {
      if (isFieldSchema(item)) {
        const formField = item as FormFieldT;
        if (isInSectionContext) {
          sectionFields.push(formField);
        }
        if (formField.followUpQuestionList && formField.followUpQuestionList.length > 0) {
          processItemsRecursive(formField.followUpQuestionList, isInSectionContext);
        }
      } else if (isSectionSchema(item) && Array.isArray(item.fields)) {
        const formSection = item as FormSectionT;
        processItemsRecursive(formSection.fields, true);
      }
    }
  }
  processItemsRecursive(formItems, false);
  return sectionFields;
}

export function deepFlattenAllFormFields(formItems: FormItemT[]): FormFieldT[] {
  const allFields: FormFieldT[] = [];

  // Use a single recursive function to avoid overhead
  function recurse(items: FormItemT[] | null | undefined): void {
    if (!items?.length) return;

    for (let i = 0; i < items.length; i++) {
      const item = items[i];

      if (isFieldSchema(item)) {
        // Only clone if we actually have follow-ups to process
        if (item.inputType === 'yesNo' && item.followUpQuestionList?.length) {
          allFields.push({
            ...item,
            followUpQuestionList: deepFlattenAllFormFields(item.followUpQuestionList),
          } as FormFieldT);
        } else {
          allFields.push(item as FormFieldT);
        }
      } else if (isSectionSchema(item)) {
        // Sections are transparent in a flat list, just dive into children
        recurse(item.fields);
      }
    }
  }

  recurse(formItems);
  return allFields;
}

export function findItemById(itemList: FormItemT[] | null | undefined, targetId: string): FormItemT | undefined {
  if (!itemList) {
    return undefined;
  }
  for (const item of itemList) {
    if (item.id === targetId) {
      return item;
    }
    if (isFieldSchema(item)) {
      const formField = item as FormFieldT;
      if (formField.followUpQuestionList) {
        const foundInFollowUp = findItemById(formField.followUpQuestionList, targetId);
        if (foundInFollowUp) {
          return foundInFollowUp;
        }
      }
    } else if (isSectionSchema(item) && Array.isArray(item.fields)) {
      const formSection = item as FormSectionT;
      const foundInChildren = findItemById(formSection.fields, targetId);
      if (foundInChildren) {
        return foundInChildren;
      }
    }
  }
  return undefined;
}

export function populateHierarchyInfo(
  items: FormItemT[] | undefined | null,
  directParentSection: string | null = null,
  grandParentSection: string | null = null,
  parentId: string | null = null,
  isFollowUp = false,
  directParentSectionTitle: TextWithTranslationsT | null = null,
  grandParentSectionTitle: TextWithTranslationsT | null = null,
): FormItemT[] {
  if (!items) return [];

  return items.map((item) => {
    if (isFieldSchema(item)) {
      const newField = {
        ...item,
        section: directParentSection,
        parentSection: grandParentSection,
        parent: parentId,
        isFollowUp,
        sectionTitle: directParentSectionTitle || {},
        parentSectionTitle: grandParentSectionTitle,
      };
      if (newField.followUpQuestionList && newField.followUpQuestionList.length > 0) {
        newField.followUpQuestionList = populateHierarchyInfo(
          newField.followUpQuestionList,
          directParentSection,
          grandParentSection,
          newField.id,
          true,
          directParentSectionTitle,
          grandParentSectionTitle,
        );
        if (newField.followUpQuestionList.length === 1 && isFieldSchema(newField.followUpQuestionList[0])) {
          newField.followUpField = newField.followUpQuestionList[0].field;
        }
      }
      return newField;
    } else if (isSectionSchema(item)) {
      const newSection = { ...item };
      newSection.fields = populateHierarchyInfo(
        item.fields,
        item.section,
        directParentSection,
        parentId,
        isFollowUp,
        item.sectionTitle,
        directParentSectionTitle,
      );
      return newSection;
    }
    return item;
  });
}

export function getTargetIndicatorPath({ e, current, path }: { e: React.DragEvent; current: HTMLDivElement; path: number[] }) {
  const rect = current.getBoundingClientRect();
  const mouseY = e.clientY;
  const midpoint = rect.top + rect.height / 2;

  const currentItemIndexInSiblings = path[path.length - 1] as number;
  const parentPathSegments = path.slice(0, -1);

  const targetIndicatorPath =
    mouseY <= midpoint
      ? [...parentPathSegments, currentItemIndexInSiblings]
      : [...parentPathSegments, currentItemIndexInSiblings + 1];

  return { targetIndicatorPath, currentItemIndexInSiblings, parentPathSegments };
}

export function checkIfSectionDraggedInsideSection({
  formSchema,
  draggedItem,
  path,
}: {
  formSchema: FormItemT[];
  draggedItem: DraggedItem;
  path: number[];
}) {
  const parentPath = path.slice(0, -1);
  const parent = findItemByPath(formSchema, parentPath);
  const item = draggedItem.itemData as FormItemT;
  if (parent) {
    if (isSectionSchema(parent) && !parent.isAdvanced) {
      if (draggedItem.type === DRAG_ITEM_TYPES.PALETTE) {
        if ((draggedItem.itemData as ComponentInputTypeT) === 'section') {
          return true;
        }
      } else {
        /* eslint-disable-next-line no-lonely-if */
        if (isSectionSchema(item) && !item.isAdvanced) {
          return true;
        }
      }
    }
  }
  return false;
}

function escapeRegExp(string: string): string {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
function collectAllExistingSectionNames(items: FormItemT[]): Set<string> {
  const sectionNames = new Set<string>();

  function CTraverse(currentItems: FormItemT[]): void {
    for (const item of currentItems) {
      if (isSectionSchema(item)) {
        sectionNames.add(item.section);
        if (item.fields && item.fields.length > 0) {
          traverse(item.fields);
        }
      } else if (isFieldSchema(item)) {
        if (item.followUpQuestionList && item.followUpQuestionList.length > 0) {
          traverse(item.followUpQuestionList as FormItemT[]);
        }
      }
    }
  }
  const traverse = CTraverse;

  traverse(items);
  return sectionNames;
}

export function getUniqueSectionName(formItems: FormItemT[], baseSectionName: string) {
  const existingSectionNamesSet = collectAllExistingSectionNames(formItems);
  const existingSectionNamesArray = Array.from(existingSectionNamesSet);

  let maxSuffix = 0;
  let baseNameFound = false;

  const suffixRegex = new RegExp(`^${escapeRegExp(baseSectionName)}_(\\d+)$`);

  for (const name of existingSectionNamesArray) {
    if (name === baseSectionName) {
      baseNameFound = true;
    } else {
      const match = name.match(suffixRegex);
      if (match && match[1]) {
        const suffixNumber = parseInt(match[1], 10);
        /* eslint-disable-next-line */
        if (!isNaN(suffixNumber)) {
          maxSuffix = Math.max(maxSuffix, suffixNumber);
          baseNameFound = true;
        }
      }
    }
  }

  if (!baseNameFound) {
    return { section: baseSectionName, isUnique: true };
  }

  return { section: `${baseSectionName}_${maxSuffix + 1}`, isUnique: false };
}

function collectAllExistingFieldNames(
  items: FormItemT[] | undefined | null,
  existingNames: Set<string> = new Set(),
): Set<string> {
  if (!items) {
    return existingNames;
  }

  for (const item of items) {
    if (isFieldSchema(item)) {
      existingNames.add(item.field);
      if (item.followUpQuestionList) {
        collectAllExistingFieldNames(item.followUpQuestionList, existingNames);
      }
    } else if (isSectionSchema(item)) {
      collectAllExistingFieldNames(item.fields, existingNames);
    }
  }
  return existingNames;
}

export function getUniqueFieldName(formItems: FormItemT[], baseFieldName: string): { field: string; isUnique: boolean } {
  const existingFieldNamesSet = collectAllExistingFieldNames(formItems);
  const existingSectionNamesArray = Array.from(existingFieldNamesSet);

  let maxSuffix = 0;
  let baseNameInUse = false;

  if (existingFieldNamesSet.has(baseFieldName)) {
    baseNameInUse = true;
  }

  const suffixRegex = new RegExp(`^${escapeRegExp(baseFieldName)}_(\\d+)$`);

  for (const name of existingSectionNamesArray) {
    if (name !== baseFieldName) {
      const match = name.match(suffixRegex);
      if (match && match[1]) {
        const suffixNumber = parseInt(match[1], 10);
        /* eslint-disable-next-line */
        if (!isNaN(suffixNumber)) {
          maxSuffix = Math.max(maxSuffix, suffixNumber);
          baseNameInUse = true;
        }
      }
    }
  }

  if (!baseNameInUse) {
    return { field: baseFieldName, isUnique: true };
  }

  return { field: `${baseFieldName}_${maxSuffix + 1}`, isUnique: false };
}

export function processItemsToEnsureUniqueFieldNames(
  itemsToProcess: FormItemT[],
  allItemsSnapshot: FormItemT[],
  assignedNamesInThisRun: Set<string>,
): FormItemT[] {
  return itemsToProcess.map((item) => {
    if (isFieldSchema(item)) {
      let currentBaseForUniqueName = item.field;
      let finalUniqueFieldName = '';

      while (true) {
        const globalCheck = getUniqueFieldName(allItemsSnapshot, currentBaseForUniqueName);
        finalUniqueFieldName = globalCheck.field;

        if (!assignedNamesInThisRun.has(finalUniqueFieldName)) {
          break;
        }

        if (globalCheck.isUnique && finalUniqueFieldName === currentBaseForUniqueName) {
          currentBaseForUniqueName = `${finalUniqueFieldName}_1`;
        } else {
          currentBaseForUniqueName = finalUniqueFieldName;
        }
      }
      assignedNamesInThisRun.add(finalUniqueFieldName);

      const updatedFieldItem: FormFieldT = { ...item, field: finalUniqueFieldName };

      if (updatedFieldItem.followUpQuestionList) {
        updatedFieldItem.followUpQuestionList = processItemsToEnsureUniqueFieldNames(
          updatedFieldItem.followUpQuestionList,
          allItemsSnapshot,
          assignedNamesInThisRun,
        );
      }
      return updatedFieldItem;
    } else if (isSectionSchema(item)) {
      const updatedNestedSectionFields = processItemsToEnsureUniqueFieldNames(
        item.fields,
        allItemsSnapshot,
        assignedNamesInThisRun,
      );
      return { ...item, fields: updatedNestedSectionFields };
    }
    return item;
  });
}

export function removeFollowupOptionPath<T>(a: any[], b: T[]): T[] {
  const bCopy = [...b];
  const indexToRemove = a.length;

  if (indexToRemove >= 0 && indexToRemove < bCopy.length) {
    bCopy.splice(indexToRemove, 1);
    return bCopy;
  } else {
    return bCopy;
  }
}

const reservedKeywords = new Set([
  'break',
  'case',
  'catch',
  'class',
  'const',
  'continue',
  'debugger',
  'default',
  'delete',
  'do',
  'else',
  'export',
  'extends',
  'finally',
  'for',
  'function',
  'if',
  'import',
  'in',
  'instanceof',
  'let',
  'new',
  'return',
  'super',
  'switch',
  'this',
  'throw',
  'try',
  'typeof',
  'var',
  'void',
  'while',
  'with',
  'yield',
  'enum',
  'implements',
  'interface',
  'package',
  'private',
  'protected',
  'public',
  'static',
  'await',
  'null',
  'true',
  'false',
]);

const validReason = {
  shouldBeString: 'inputKeyValidation.shouldBeString',
  shouldNotExceed30Chars: 'inputKeyValidation.shouldNotExceed30Chars',
  reservedKeyword: 'inputKeyValidation.reservedKeyword',
  restrictedField: 'inputKeyValidation.restrictedField',
  mustStartWithLetter: 'inputKeyValidation.mustStartWithLetter',
  invalidCharacters: 'inputKeyValidation.invalidCharacters',
};

export function isValidKey(inputKey: string) {
  if (!isString(inputKey)) return { valid: false, reason: validReason.shouldBeString };

  const trimmedKey = inputKey.trim();
  const cleanedKey = trimmedKey.replace(/\s+/g, '');

  if (cleanedKey.length > 30) {
    return { valid: false, reason: validReason.shouldNotExceed30Chars };
  }

  if (reservedKeywords.has(cleanedKey)) {
    return { valid: false, reason: validReason.reservedKeyword };
  }

  if (Object.values(COMPONENT_ADVANCED_FIELDS).includes(cleanedKey as COMPONENT_ADVANCED_FIELDS)) {
    return { valid: false, reason: validReason.restrictedField };
  }

  if (!/^[A-Za-z]/.test(cleanedKey)) {
    return {
      valid: false,
      reason: validReason.mustStartWithLetter,
    };
  }

  if (!/^[A-Za-z0-9_.\- ]+$/.test(cleanedKey)) {
    return {
      valid: false,
      reason: validReason.invalidCharacters,
    };
  }

  return { valid: true, key: cleanedKey };
}

export const createNewField = (formItems: FormItemT[], inputType: ComponentInputTypeT): FormFieldT => {
  const { defaultValue } = getFormSchemaByInputType(inputType);
  const newField: FormFieldT = {
    ...(defaultValue as FormFieldT),
    id: uuidv4(),
    timestamp: Date.now(),
    order: 0,
  };
  if (inputType === 'yesNo') {
    newField.followUpQuestionList = [];
  }
  const { field } = getUniqueFieldName(formItems, newField.field);
  newField.field = field;
  return newField;
};

export const createAdvancedField = (formItems: FormItemT[], inputType: ComponentInputTypeT): FormSectionT => {
  const { section, defaultValue, sectionTitle } = getFormSchemaByInputType(inputType);
  const newField: FormSectionT = {
    id: uuidv4(),
    isAdvanced: true,
    section: section || 'New Section',
    sectionTitle,
    fields: [],
  };
  const fields = (defaultValue as FormFieldT[])?.map((field) => {
    if (
      isFieldSchema(field) &&
      field.inputType === FORM_COMPONENT_BASIC_INPUT_TYPE.yesNo &&
      field?.followUpQuestionList &&
      field?.followUpQuestionList?.length > 0
    ) {
      field.followUpQuestionList = field.followUpQuestionList.map((followUpQuestion) => {
        return {
          ...followUpQuestion,
          timestamp: Date.now(),
          id: uuidv4(),
        };
      });
    }
    return { ...field, timestamp: Date.now(), id: uuidv4() };
  }) as FormFieldT[];

  newField.fields = [...fields];
  const { field } = getUniqueFieldName(formItems, fields[0].field);
  fields[0].field = field;

  newField.fields = processItemsToEnsureUniqueFieldNames(newField.fields, formItems, new Set());

  return newField;
};

export const createNewSection = (formItems: FormItemT[], defaultText: string): FormSectionT => {
  const { section } = getUniqueSectionName(formItems, defaultText || 'Section');
  function capitalizeWords(str: string) {
    return str
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.substring(1))
      .join(' ');
  }
  const sectionKey = capitalizeWords(section);
  return {
    id: uuidv4(),
    section: sectionKey,
    sectionTitle: { en: sectionKey, fr: sectionKey },
    fields: [],
    isAdvanced: false,
  };
};

export const updateMissingTranslations = <T extends Record<string, any>>(
  obj: T,
  key: keyof T,
  defaultLanguage: string,
  languages: string[],
): T => {
  const original = obj?.[key];
  if (!original || /* eslint-disable-line */ !isObject(original)) return obj;

  /* eslint-disable-next-line */
  const defaultText = original[defaultLanguage]?.trim?.();
  if (!defaultText) return obj; // Nothing to propagate

  const updated = { ...obj, [key]: { ...original } };

  languages.forEach((lang) => {
    if (lang !== defaultLanguage) {
      const current = updated[key][lang];
      /* eslint-disable-next-line */
      if (!current || !current.trim()) {
        updated[key][lang] = defaultText;
      }
    }
  });

  return updated;
};

export function attachDataTag(html: string): string {
  return html.replace(/<span>\[([^\]]+)\]<\/span>/g, (_match, tag) => `<span data-tag="${tag}">[${tag}]</span>`);
}
